// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zonesCoordinat_zones__left__1cYuo {
  width: calc(100% - 380px);
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e0e0e0; }
  .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_area__74kAf {
    display: flex;
    position: relative;
    height: max-content;
    width: 100%;
    background-color: white; }
    .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_area__74kAf .zonesCoordinat_image_container__sA3zW {
      position: relative;
      width: max-content;
      word-wrap: break-word; }
      .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_area__74kAf .zonesCoordinat_image_container__sA3zW .zonesCoordinat_newCoordinates__jYEfZ {
        position: absolute;
        z-index: 5;
        background-color: #ffffff40; }
      .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_area__74kAf .zonesCoordinat_image_container__sA3zW .zonesCoordinat_draw__M2J93 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%; }
      .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_area__74kAf .zonesCoordinat_image_container_img__hjgzv {
        height: 100%;
        width: 100%;
        object-fit: contain;
        object-position: top left; }
    .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_area__74kAf .zonesCoordinat_scale__vHKwm {
      position: absolute;
      bottom: 20px;
      right: 20px;
      color: #ffffff;
      z-index: 100;
      cursor: pointer;
      transition: all 0.4s; }
    .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_area__74kAf .zonesCoordinat_remove__5KxNz {
      position: absolute;
      top: 20px;
      right: 20px;
      height: 50px;
      width: 20px;
      height: 20px;
      cursor: pointer;
      transition: all 0.4s;
      z-index: 101;
      color: white;
      transform: translate(43px, -43px);
      opacity: 10 !important; }
      .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_area__74kAf .zonesCoordinat_remove__5KxNz:hover {
        color: #dad72f; }
  .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_footer__rSxlj {
    gap: 10px;
    height: 48px;
    width: 100%;
    padding: 10px 30px 20px 10px;
    background-color: #ffffff;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative; }
    .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_footer__text__qsFg\\+ {
      position: absolute;
      top: 10px;
      left: 10px;
      font-weight: 600;
      font-size: 14px; }
      .zonesCoordinat_zones__left__1cYuo .zonesCoordinat_footer__text__qsFg\\+ span {
        color: red; }

.zonesCoordinat_oldCoord__iMsyQ {
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  cursor: pointer;
  background: rgba(33, 33, 33, 0.6);
  color: #ffffff;
  border: 1px solid #666666;
  font-weight: 400;
  font-size: 8px;
  line-height: 9px;
  word-wrap: break-word; }
`, "",{"version":3,"sources":["webpack://./src/pages/camera/modal/zones/coordinates/zonesCoordinat.module.scss"],"names":[],"mappings":"AACE;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gCAAgC,EAAA;EANjC;IASG,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,uBAAuB,EAAA;IAb1B;MAgBK,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB,EAAA;MAlB1B;QAqBO,kBAAkB;QAClB,UAAU;QACV,2BAA2B,EAAA;MAvBlC;QA2BO,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;QACX,YAAY,EAAA;MA/BnB;QAmCO,YAAY;QACZ,WAAW;QACX,mBAAmB;QACnB,yBAAyB,EAAA;IAtChC;MA2CK,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,cAAc;MACd,YAAY;MACZ,eAAe;MACf,oBAAoB,EAAA;IAjDzB;MAqDK,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,eAAe;MACf,oBAAoB;MACpB,YAAY;MACZ,YAAY;MACZ,iCAAiC;MACjC,sBAAsB,EAAA;MAhE3B;QAmEO,cAAwB,EAAA;EAnE/B;IAyEG,SAAS;IACT,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB,EAAA;IAjFrB;MAoFK,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,gBAAgB;MAChB,eAAe,EAAA;MAxFpB;QA2FO,UAAU,EAAA;;AAOpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB,EAAA","sourcesContent":[".zones {\n  &__left {\n    width: calc(100% - 380px);\n    height: 100%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    border-bottom: 1px solid #e0e0e0;\n\n    .area {\n      display: flex;\n      position: relative;\n      height: max-content;\n      width: 100%;\n      background-color: white;\n\n      .image_container {\n        position: relative;\n        width: max-content;\n        word-wrap: break-word;\n\n        .newCoordinates {\n          position: absolute;\n          z-index: 5;\n          background-color: #ffffff40;\n        }\n\n        .draw {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 100%;\n          height: 100%;\n        }\n\n        &_img {\n          height: 100%;\n          width: 100%;\n          object-fit: contain;\n          object-position: top left;\n        }\n      }\n\n      .scale {\n        position: absolute;\n        bottom: 20px;\n        right: 20px;\n        color: #ffffff;\n        z-index: 100;\n        cursor: pointer;\n        transition: all 0.4s;\n      }\n\n      .remove {\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        height: 50px;\n        width: 20px;\n        height: 20px;\n        cursor: pointer;\n        transition: all 0.4s;\n        z-index: 101;\n        color: white;\n        transform: translate(43px, -43px);\n        opacity: 10 !important;\n\n        &:hover {\n          color: rgb(218, 215, 47);\n        }\n      }\n    }\n\n    .footer {\n      gap: 10px;\n      height: 48px;\n      width: 100%;\n      padding: 10px 30px 20px 10px;\n      background-color: #ffffff;\n      display: flex;\n      justify-content: flex-end;\n      align-items: flex-end;\n      position: relative;\n\n      &__text {\n        position: absolute;\n        top: 10px;\n        left: 10px;\n        font-weight: 600;\n        font-size: 14px;\n\n        span {\n          color: red;\n        }\n      }\n    }\n  }\n}\n\n.oldCoord {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  background: rgba(33, 33, 33, 0.6);\n  color: #ffffff;\n  border: 1px solid #666666;\n  font-weight: 400;\n  font-size: 8px;\n  line-height: 9px;\n  word-wrap: break-word;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"zones__left": `zonesCoordinat_zones__left__1cYuo`,
	"area": `zonesCoordinat_area__74kAf`,
	"image_container": `zonesCoordinat_image_container__sA3zW`,
	"newCoordinates": `zonesCoordinat_newCoordinates__jYEfZ`,
	"draw": `zonesCoordinat_draw__M2J93`,
	"image_container_img": `zonesCoordinat_image_container_img__hjgzv`,
	"scale": `zonesCoordinat_scale__vHKwm`,
	"remove": `zonesCoordinat_remove__5KxNz`,
	"footer": `zonesCoordinat_footer__rSxlj`,
	"footer__text": `zonesCoordinat_footer__text__qsFg+`,
	"oldCoord": `zonesCoordinat_oldCoord__iMsyQ`
};
export default ___CSS_LOADER_EXPORT___;
